import React, { useEffect, useState } from 'react';

interface ToastErrorProps {
  error: string | null;
  onDismiss: () => void;
}

const ToastError: React.FC<ToastErrorProps> = ({ error, onDismiss }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  
  useEffect(() => {
    if (error) {
      setIsVisible(true);
      
      // Automatically dismiss after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onDismiss, 300); // Wait for fade out animation before removing from DOM
      }, 5000);
      
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [error, onDismiss]);

  if (!error) return null;

  return (
    <div 
      className={`
        fixed bottom-28 left-4 right-4 flex justify-center z-50
        transition-all duration-300 ease-out
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12 pointer-events-none'}
      `}
    >
      <div className="max-w-xs w-full bg-white border border-gray-200 rounded-xl shadow-lg relative" role="alert">
        <div className="flex p-4">
          <div className="shrink-0">
            <svg className="shrink-0 size-4 text-red-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
            </svg>
          </div>
          <div className="ms-3 pr-8">
            <p className="text-sm text-gray-700">
              {error}
            </p>
          </div>
          <button
            type="button"
            className="absolute top-2 right-2 inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-gray-800 opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100"
            onClick={() => {
              setIsVisible(false);
              setTimeout(onDismiss, 300); // Wait for animation
            }}
            aria-label="Close"
          >
            <span className="sr-only">Close</span>
            <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToastError;